export default __webpack_public_path__ + "static/RVRPG-6a110c39ae1b6d94419d85003b8ff8bd.svg";